import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isSupplierPortalUser } from '../lib/permissions';

/** Sólo el rol Proveedor entra a `/proveedor/*`; cualquier otro usuario es redirigido a `/`. */
export function SupplierPortalRoute() {
  const { user } = useAuth();
  return isSupplierPortalUser(user) ? <Outlet /> : <Navigate to="/" replace />;
}
